import type {
  GetContactDataRequestBody,
  GetContactDataResponseBody,
  UpdateContactDataRequestBody,
} from "./../../models/managementsUpdate/managementsUpdateContact/managementsUpdateContact.model";
import axios from "axios";

import { API_ENDPOINTS } from "../../../config/endpoints.config";
import { PostCallCenterResponseBody } from "../../models/managements/managements.model";

const updateContactData = (
  updateContactDataRequestBody: UpdateContactDataRequestBody[],
  token: string
): Promise<PostCallCenterResponseBody[]> =>
  axios

    .put(API_ENDPOINTS.CLIENT_CUPS_CONTACT_DATA, updateContactDataRequestBody, {
      headers: {
        Authorization: token,
      },
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const getContactData = async (
  getContactDataRequestBody: GetContactDataRequestBody,
  token: string,
  abortController: AbortController
): Promise<GetContactDataResponseBody> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_CUPS_CONTACT_DATA, getContactDataRequestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortController.signal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const updateShippingAddress = async (
  updateShippingAddressRequestBody: any,
  token: string
): Promise<PostCallCenterResponseBody[]> =>
  await axios
    .put(
      API_ENDPOINTS.CLIENT_CUPS_SHIPPING_ADDRESS,
      updateShippingAddressRequestBody,
      {
        headers: {
          Authorization: token,
        },
      }
    )
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

export { updateContactData, updateShippingAddress, getContactData };
